import { useEffect, useRef, useState } from "react"
import {
    createSnapshot,
    deleteSnapshot,
    deploySnapshot,
    downloadSnapshot,
    getBackupList,
} from "../../services/tsQueryApis"
import MyModal from "../MyModal"
import Table from "../Table"
import { API_ROUTES } from "../../utils/constants"
import { toast } from "react-toastify"
import actionHelper from "../../lib/actionHelper"
import { useAuth } from "../../lib/useAuth"

const cols = [
    {
        name: "نام مستعار",
        colSpan: 1,
    },

    {
        name: "",
        colSpan: 1,
    },
]

const BackupServerModal = ({ user, server }) => {
    const [isOpen, setIsOpen] = useState(false)
    const toggleModal = () => setIsOpen(!isOpen)
    const updateUiInterval = useRef(null)

    const { isAuthenticated } = useAuth()
    const [backupList, setBackupList] = useState([])

    const updateUi = () => {
        if (server) {
            getBackupList(server.id).then(({ data }) => {
                setBackupList(data)
            })
        }
    }

    const createRows = (backups) => {
        return backups?.map((b) => {
            let obj = {
                name: b,
                buttons: (
                    <div className="flex justify-end gap-5">
                        <button
                            onClick={() => {
                                toggleModal()
                                if (server.status == "offline") {
                                    toast.error("سرور خاموش میباشد")
                                    return
                                }
                                actionHelper({
                                    confirmation: {
                                        label: "تمام اطلاعات کنونی سرور پاک میشود و بکاپ جدید ریخته میشود ایا مطمئن هستید؟",
                                        actionLabel: "بازگردانی",
                                        color: "warning",
                                    },
                                    callback: () => deploySnapshot(server.id, b),
                                    texts: {
                                        success: "بازگردانی با موفقیت انجام شد",
                                        pending: "درحال بازگردانی",
                                    },
                                })
                            }}
                            className="styled-button warning"
                        >
                            بازگردانی
                        </button>
                        <button
                            onClick={() => {
                                toggleModal()
                                toast.promise(deleteSnapshot(server.id, b), {
                                    pending: "درحال حذف",
                                    success: "با موفقیت حذف شد",
                                    error: "Error",
                                })
                            }}
                            className="styled-button danger"
                        >
                            حذف
                        </button>
                        <button
                            onClick={async () => {
                                const snapshot = await downloadSnapshot(server.id, b)
                                const url = window.URL.createObjectURL(new Blob([snapshot.data]))
                                const link = document.createElement("a")
                                link.href = url
                                link.setAttribute("download", b)
                                document.body.appendChild(link)
                                link.click()
                            }}
                            target="_blank"
                            rel="noreferrer"
                            className="styled-button success"
                        >
                            دانلود
                        </button>
                    </div>
                ),
            }
            return obj
        })
    }

    useEffect(() => {
        if (isAuthenticated && isOpen) {
            updateUi()
            updateUiInterval.current = setInterval(updateUi, 5000)
        } else {
            if (updateUiInterval.current) clearInterval(updateUiInterval.current)
        }
    }, [isAuthenticated, isOpen])

    return (
        <>
            <button
                onClick={toggleModal}
                style={{ backgroundColor: "#38BDF8" }}
                className="flex gap-2 justify-center border  text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-slate-600 focus:outline-none focus:shadow-outline"
            >
                <img src="assets/icons/server.svg" width="20px" height="20px" />
                بکاپ ها
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="900px" height="500px">
                <div className="mt-10">
                    <button
                        onClick={() => {
                            if (server.status == "offline") {
                                toast.error("سرور خاموش میباشد")
                                return
                            }
                            toast
                                .promise(createSnapshot(server.id), {
                                    pending: "درحال ساخت بکاپ",
                                    success: "بکاپ ساخته شد",
                                })
                                .catch((err) => {
                                    console.error(err)
                                })
                        }}
                        className="styled-button mb-5 px-4"
                    >
                        بکاپ جدید
                    </button>
                    <Table cols={cols} rows={createRows(backupList)} />
                </div>
            </MyModal>
        </>
    )
}

export default BackupServerModal
